import React from 'react';
import { Create, useForm, useSelect } from '@refinedev/antd';
import { Form, Input, Select } from 'antd';
import { PermissionDto } from '@wellverse/shared-ts';

export const RoleCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'roles' });
  const { selectProps: permissionSelectProps } = useSelect<PermissionDto>({
    resource: 'permissions',
    optionLabel: (item) => `${item.resource}:${item.action}`,
    optionValue: 'id',
  });

  return (
    <Create resource="roles" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Name" name="name" rules={[{ required: true }]}>
          <Input placeholder="e.g. Content Manager" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={3} placeholder="Role description..." />
        </Form.Item>
        <Form.Item label="Permissions" name="permissionIds">
          <Select
            {...permissionSelectProps}
            mode="multiple"
            placeholder="Select permissions"
          />
        </Form.Item>
      </Form>
    </Create>
  );
};
